@import "config";

.spinner {
	border-radius: 50%;
	animation: spin 2s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.small {
	@extend .spinner;

	min-width: 12px;
	min-height: 12px;
	border: 1.5px solid $color-dark-d3;
	border-top: 1.5px solid $color-dark-d1;
}

.medium {
	@extend .spinner;

	width: 20px;
	height: 20px;
	border: 2.5px solid $color-dark-d3;
	border-top: 2.5px solid $color-dark-d1;
}

.large {
	@extend .spinner;

	min-width: 35px;
	min-height: 35px;
	border: 3.5px solid $color-dark-d3;
	border-top: 3.5px solid $color-dark-d1;
}
